import { resourceUpserters } from 'app-components/flux/core';
import { handleActions } from 'redux-actions';

import * as actions from './a2aTransfersActions';
import {
  A2A_TRANSFERS_REDUCER_KEY,
  A2aTransferProps,
  type A2aTransferStore,
  A2aTransferStoreProps,
  mkA2aTransferStore,
} from './a2aTransfersTypes';

const a2aTransfersReducer = handleActions<
  A2aTransferStore,
  // get
  | ReturnType<typeof actions.getA2aTransfers>
  | ReturnType<typeof actions.getA2aTransfersSuccess>
  | ReturnType<typeof actions.getA2aTransfersFailure>
  // cancel
  // | ReturnType<typeof actions.cancelA2aTransfer>
  // | ReturnType<typeof actions.cancelA2aTransferSuccess>
  // | ReturnType<typeof actions.cancelA2aTransferFailure>
>(
  {
    [actions.getA2aTransfers.type]: (state) => state.merge({ isLoading: true }),
    [actions.getA2aTransfersSuccess.type]: (state, { payload }) => resourceUpserters.upsertResources(state, payload),
    [actions.getA2aTransfersFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError<A2aTransferProps, A2aTransferStoreProps>(state, error),
  },
  mkA2aTransferStore(),
);

export { A2A_TRANSFERS_REDUCER_KEY };

export default a2aTransfersReducer;
